// extracted by mini-css-extract-plugin
module.exports = {"root":"CopyPreview_root__216Nr","copyPreviewTitle":"CopyPreview_copyPreviewTitle__1fEYn","onboardingImage":"CopyPreview_onboardingImage__2VSib"};